
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from '../../../mixins';
import { PerformanceCategory, getPerformanceCategoryValues } from '../../../../types/enums';
import ProgressBar from '../../charts/ProgressBar.vue';
import { performanceCategoryToLabel, performanceCategoryToColor } from '../../../pipes';
import { PerformanceCategory } from '../../../../types/enums/performance-category';

interface PerformanceCategoryData{
	level: PerformanceCategory,
	label: string,
	color: string,
	html: string,
	progress: number,
}
@Component({
	components: {
		ProgressBar,
	}
})
export default class PerformanceLevelPreview extends Mixins(VuetifyMixin){

	@Prop({ default: PerformanceCategory.Recreational }) category: PerformanceCategory;
	@Prop({ type: Boolean, default: false }) hideDetails: boolean;

	@Prop({ type: Boolean, default: false }) over18: boolean;

	get Ready(): boolean{
		return this.PerformanceLevel !== undefined;
	}

	get SlotProps(): Record<string, any>{
		return {
			...this.PerformanceLevel,
			Ready: this.Ready,
		}
	}

	get PerformanceLevel(): PerformanceCategoryData{
		var effectiveCategory = this.category;
		if( this.category < 1 )
		{
			effectiveCategory = PerformanceCategory.Recreational;
		}

		const level = this.PerformanceLevels.find(p => p.level === effectiveCategory);
		return { ...level };
	}

	get PerformanceCategories(): PerformanceCategory[]{
		return getPerformanceCategoryValues(this.over18);
	}
	get PerformanceLevels(): PerformanceCategoryData[]{
		return this.performanceLevels.filter(l => this.PerformanceCategories.findIndex(p => p === l.level) !== -1)
	}

	performanceLevels: PerformanceCategoryData[] = [
		{
			level: PerformanceCategory.Recreational,
			label: performanceCategoryToLabel(PerformanceCategory.Recreational),
			color: performanceCategoryToColor(PerformanceCategory.Recreational),
			html: 'This is a non-competitive level of sport. You play for fun, to see and be with your friends and make new ones, and to stay in shape.',
			progress: 25,
		},
		{
			level: PerformanceCategory.Competitive,
			label: performanceCategoryToLabel(PerformanceCategory.Competitive),
			color: performanceCategoryToColor(PerformanceCategory.Competitive),
			html: 'This is a competitive level of sport. You have been selected into a team based on your talent and skill, and you compete with and against your peers in a league where scores and standings are kept.',
			progress: 40,
		},
		{
			level: PerformanceCategory.HighPerformance,
			label: performanceCategoryToLabel(PerformanceCategory.HighPerformance),
			color: performanceCategoryToColor(PerformanceCategory.HighPerformance),
			html: 'This is a competitive level of sport, where the focus of the environment is to develop elite athletes who can progress on to a higher competitive level, typically either post-secondary sport or professional sport.',
			progress: 60,
		},
		{
			level: PerformanceCategory.College,
			label: performanceCategoryToLabel(PerformanceCategory.College),
			color: performanceCategoryToColor(PerformanceCategory.College),
			html: 'This is a competitive level of sport, where the focus of the environment is to develop elite student athletes who may progress on to a professional career.',
			progress: 60,
		},
		{
			level: PerformanceCategory.ProAcademy,
			label: performanceCategoryToLabel(PerformanceCategory.ProAcademy),
			color: performanceCategoryToColor(PerformanceCategory.ProAcademy),
			html: 'This competitive level is the youth team of a professional club, whose aim is to develop players to play for the senior or adult team in the club.',
			progress: 80,
		},
		{
			level: PerformanceCategory.Professional,
			label: performanceCategoryToLabel(PerformanceCategory.Professional),
			color: performanceCategoryToColor(PerformanceCategory.Professional),
			html: 'This competitive level is a professional club, competing at the professional level.',
			progress: 80,
		},
		{
			level: PerformanceCategory.International,
			label: performanceCategoryToLabel(PerformanceCategory.International),
			color: performanceCategoryToColor(PerformanceCategory.International),
			html: 'This is the highest competitive level for sport. International athletes represent their country in youth and senior international competitions.',
			progress: 100,
		},
		{
			level: PerformanceCategory.Recreational,
			label: performanceCategoryToLabel(-1),
			color: performanceCategoryToColor(-1),
			html: 'This is a beginner level in the sport. Start playing the sport to improve or have fun.',
			progress: 10,
		},
	];
}
